import React from 'react';
import { AdditionalTextContainer } from 'style/Main';
import { InteractiveCTAOption } from 'types';
import { MediaGallery } from 'components/MediaGallery';
import { CtaSetsButtons } from './CtaSetsButtons';
import { AdditionalText } from './AdditionalText';
import { useMainProviderContext } from 'context/main/provider';
import { wrapAnnotationWithProps } from 'queries/details/detailsQuery';
import { AnnotationItem } from 'queries/details/types';
import { cleanAdditionalText } from 'utils/functions';
import { Flex } from 'components/layout';

interface IProps {
  designOverride: boolean;
  videoRef: any;
  showContactInfoModal: boolean;
  openShowContactInfoModal: () => void;
  areControlsShown: boolean;
}

// only on sales flow
export const MediaGalleryItem = ({
  designOverride,
  videoRef,
  showContactInfoModal,
  openShowContactInfoModal,
  areControlsShown,
}: IProps) => {
  const { isPreview, isBuilderPreviewMode, response, triggerViewNotification } =
    useMainProviderContext();

  const {
    interactiveCTAs,
    viewerStatisticId,
    annotations,
    companyAnnotations,
  } = response;

  // consider in context
  const filteredInteractiveCta: InteractiveCTAOption[] = interactiveCTAs
    .filter(cta => cta.isVisible)
    .map(cta => ({
      label: cta.title,
      value: cta.url,
      type: cta.type,
      linkValue: cta.linkValue,
    }));

  const formattedVideoAnnotations = annotations.map(
    (annotation: AnnotationItem) => wrapAnnotationWithProps(annotation)
  );
  const formattedCompanyAnnotations = companyAnnotations.map(
    (annotation: AnnotationItem) =>
      wrapAnnotationWithProps(annotation, { isCompanyAnnotation: true })
  );
  const cleanedAdditionalText = cleanAdditionalText(
    response.landingPageDesign?.additionalText
  );

  return response?.inventoryItem ? (
    <Flex
      justifyContent='center'
      alignItems='center'
      className='lp-container'
      maxWidth='800px'
      style={{ alignSelf: 'flex-start' }}
    >
      {/* Video Player Section */}
      <Flex className='video-player-section'>
        <MediaGallery
          orderDetails={response}
          interactiveCTAs={filteredInteractiveCta}
          userId={triggerViewNotification ? viewerStatisticId : 0}
          media={response.inventoryItem.media}
          isPreview={isPreview}
          design={designOverride || response.playerDesign}
          videoRef={videoRef}
          renderPlayerReactions={() => null}
          showContactInfoModal={showContactInfoModal}
          openShowContactInfoModal={openShowContactInfoModal}
          annotations={[
            ...formattedVideoAnnotations,
            ...formattedCompanyAnnotations,
          ]}
          areControlsShown={areControlsShown}
          playbackData={response}
          isBuilderPreviewMode={isBuilderPreviewMode}
        />
      </Flex>
      {/* Video Player Section */}
      <Flex>
        <CtaSetsButtons />
        {cleanedAdditionalText && (
          <AdditionalTextContainer
            className='additional-text'
            withBackground
            additionalTextColor={
              response.landingPageDesign?.additionalTextColor || ''
            }
            additionalTextBackgroundColor={
              response.landingPageDesign.additionalTextBackgroundColor
            }
          >
            <AdditionalText playbackData={response} />
          </AdditionalTextContainer>
        )}
      </Flex>
      {/* CTA and Additional Text Section  */}
    </Flex>
  ) : (
    <></>
  );
};
